var angular=window.angular,ngModule;
try {ngModule=angular.module(["views"])}
catch(e){ngModule=angular.module("views",[])}
var v1="<shopping-container type=\"multi-view\" base-route=\"orders.detail\" use-quick-view=\"true\" order-id=\"$ctrl.orderId\" retailer-id=\"$ctrl.order.retailerId\" hide-nav-continue-shopping=\"true\" query-options=\"{scrollTop:false}\" hide-left-nav=\"false\"></shopping-container>";
var id1="order-details-shop.htm";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=id1;